import { Controller } from "@hotwired/stimulus"

// L'occhio di PasswordInput.js: mostra o nasconde la password (type password/text) senza inviare il form.
export default class extends Controller {
  static targets = ["input", "button", "mostra", "nascondi"]

  toggle(event) {
    event.preventDefault()
    const visibile = this.inputTarget.type === "password"
    this.inputTarget.type = visibile ? "text" : "password"
    const testo = visibile ? "Nascondi password" : "Mostra password"
    this.buttonTarget.setAttribute("aria-label", testo)
    this.buttonTarget.setAttribute("title", testo)
    this.buttonTarget.setAttribute("aria-pressed", String(visibile))
    this.mostraTarget.toggleAttribute("hidden", visibile)
    this.nascondiTarget.toggleAttribute("hidden", !visibile)
  }
}
